import { useQuery } from '@tanstack/react-query';
import { userActivityApi } from '@/services/api/userActivityApi';

export function useUserTimeline(userId: number | undefined, params?: { page?: number; per_page?: number; event_type?: string; start_date?: string; end_date?: string }) {
  return useQuery({
    queryKey: ['user-activity', 'timeline', userId, params],
    queryFn: () => userActivityApi.getTimeline(userId!, params),
    enabled: !!userId,
  });
}

export function useUserSummary(userId: number | undefined, startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['user-activity', 'summary', userId, startDate, endDate],
    queryFn: () => userActivityApi.getUserSummary(userId!, startDate, endDate),
    enabled: !!userId,
  });
}

export function useTeamSummary(startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['user-activity', 'team-summary', startDate, endDate],
    queryFn: () => userActivityApi.getTeamSummary(startDate, endDate),
  });
}

export function usePresence() {
  return useQuery({
    queryKey: ['user-activity', 'presence'],
    queryFn: () => userActivityApi.getPresence(),
    refetchInterval: 30_000,
  });
}

export function useActivityHeatmap(userId: number | undefined, startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['user-activity', 'heatmap', userId, startDate, endDate],
    queryFn: () => userActivityApi.getHeatmap(userId!, startDate, endDate),
    enabled: !!userId,
  });
}

export function useUserPerformance(userId: number | undefined, startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['user-activity', 'performance', userId, startDate, endDate],
    queryFn: () => userActivityApi.getPerformance(userId!, startDate, endDate),
    enabled: !!userId,
  });
}
